import { apiClient } from './api';
import { API_ENDPOINTS, APIHeadersWithAuth } from '../globalConstants';
import type { Customer, CustomerStatement } from '@/lib/types';

export interface CustomerInput {
    name: string;
    phone: string;
    email?: string;
    address?: string;
    notes?: string;
    customerType?: string;
}

export async function listCustomers(shopId: number | string): Promise<Customer[]> {
    const res = await apiClient.get<{ data: any[] }>(
        API_ENDPOINTS.customers.LIST(shopId),
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function createCustomer(
    shopId: number | string,
    input: CustomerInput
): Promise<Customer> {
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.customers.CREATE(shopId),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function updateCustomer(
    shopId: number | string,
    id: number | string,
    input: Partial<CustomerInput>
): Promise<Customer> {
    const res = await apiClient.put<{ data: any }>(
        API_ENDPOINTS.customers.UPDATE(shopId, id),
        input,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function deleteCustomer(
    shopId: number | string,
    id: number | string
): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.customers.DELETE(shopId, id), {
        headers: APIHeadersWithAuth(),
    });
}

export interface CollectBalanceInput {
    amount: number;
    paymentMethod?: string;
    note?: string;
}

export async function collectBalance(
    shopId: number | string,
    id: number | string,
    input: CollectBalanceInput | number
): Promise<Customer> {
    const payload = typeof input === 'number' ? { amount: input } : input;
    const res = await apiClient.post<{ data: any }>(
        API_ENDPOINTS.customers.COLLECT(shopId, id),
        payload,
        { headers: APIHeadersWithAuth() }
    );
    return res.data;
}

export async function getCustomerStatement(
    shopId: number | string,
    id: number | string,
    from?: string,
    to?: string
): Promise<CustomerStatement> {
    const query = new URLSearchParams();
    if (from) query.set('from', from);
    if (to) query.set('to', to);
    const qs = query.toString();
    const url = `${API_ENDPOINTS.customers.STATEMENT(shopId, id)}${qs ? `?${qs}` : ''}`;
    const res = await apiClient.get<{ data: CustomerStatement }>(url, {
        headers: APIHeadersWithAuth(),
    });
    return res.data;
}

